// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"6105ffb1","845":"a90f63c3"}[chunkId] + ".chunk.js";
};